export const globalSearch = {
    tenant: {
        "aptReportLink": "{{buildingTitle}} apartment {{apartmentNum}}",
    },
    "noResults": "No results"
}